<template>
  <div class="page" v-loading.fullscreen.lock="fullscreenLoading">
    <query-form label-width="100px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.brand')">
          <brand-select v-model="queryForm.brandIds" multiple collapse-tags clearable :data="brandList" :label-prop="'brandName'"></brand-select>
        </query-form-item>
        <query-form-item :label="$t('common.designerId')">
          <el-input clearable v-model="queryForm.designerId"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.color')">
          <el-input clearable v-model="queryForm.colorCode"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.category')">
          <el-cascader
            v-model="queryForm.categoryIds"
            clearable
            :props="{ value: 'categoryId', label: 'name', multiple: true }"
            :options="categoryList"
            style="width: 100%"
            collapse-tags
          ></el-cascader>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <div class="tr mb10">
      <el-button type="primary" size="medium" @click="exportData" :loading="exportLoading">{{ $t('common.excel') }}</el-button>
      <el-dropdown class="sort-btn ml10" @command="changeSort">
        <el-button type="primary" size="medium">{{ $t('order.sorting') }}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="DESC" :disabled="queryForm.sortBy === 'DESC' ? true : false">{{ $t('buy.latestBuy') }}</el-dropdown-item>
          <el-dropdown-item command="ASC" :disabled="queryForm.sortBy === 'ASC' ? true : false">{{ $t('buy.closingSoon') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table
      ref="table"
      class="spacing-table"
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="" class-name="nopadding">
        <template slot-scope="scope">
          <div class="img-container">
            <list-img :img="scope.row.coverImg" :width="100"></list-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.productInfo')">
        <template slot-scope="scope">
          <p v-if="scope.row.brandName">
            <span class="label">{{ $t('common.brand') }}: </span>{{ scope.row.brandName }}
          </p>
          <p v-if="scope.row.productName">
            <span class="label">{{ $t('common.productName') }}: </span>{{ scope.row.productName }}
          </p>
          <p v-if="scope.row.categoryNamePath">
            <span class="label">{{ $t('common.category') }}: </span>{{ scope.row.categoryNamePath }}
          </p>
          <p v-if="scope.row.designerId" class="keep-space">
            <span class="label">{{ $t('common.designerId') }}: </span>{{ scope.row.designerId }}
          </p>
          <p class="keep-space">
            <span v-if="scope.row.colorCode" class="label">{{ $t('common.color') }}: </span>{{ scope.row.colorCode }}
            <span v-if="scope.row.size" class="label ml10">{{ $t('order.countrySize') }}: </span>{{ scope.row.size }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.price')">
        <template slot-scope="scope">
          <p class="label" v-if="isPriceWhiteList">{{ $t('common.retailPrice') }}({{ originalPriceUnit }}/{{ $t('common.incldVAT') }})</p>
          <p class="label" v-else>{{ $t('common.retailPrice') + '(' + originalPriceUnit + ')' }}</p>
          <p>{{ scope.row.retailPrice }}</p>
          <p class="label mt20" v-if="isPriceWhiteList">{{ $t('common.supplyPrice') }}({{ originalPriceUnit }}/{{ $t('common.excldVAT') }})</p>
          <p class="label mt20" v-else>{{ $t('common.supplyPrice') + '(' + originalPriceUnit + ')' }}</p>
          <p>{{ scope.row.supplyPrice }}</p>
          <p class="label mt20">{{ $t('common.discount') }}</p>
          <p>{{ scope.row.supplyPriceDiscount }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('buy.closingTime')">
        <template slot-scope="scope">
          {{ scope.row.seekEndTime | dateFormat('yyyy-MM-dd HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column width="150" :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button class="block-btn" type="primary" size="mini" @click="orderItem(scope.row)">{{ $t('buy.orderNow') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[25, 50, 100, 200]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BrandSelect from '../../components/BrandSelect';
import { getCategoryList } from '../../api/product';
import {
  getSeekList,
  seekOrder,
  getBrandList,
  exportSeekList,
} from '../../api/buy';
import ListImg from '../../components/ListImg';
import { downloadBlobFile } from '../../common/utils';

export default {
  name: 'BuyList',
  components: {
    BrandSelect,
    ListImg,
  },
  data() {
    return {
      fullscreenLoading: false,
      brandList: [],
      categoryList: [],
      queryForm: {
        brandIds: [],
        designerId: null,
        colorCode: null,
        categoryIds: [],
        pageNo: 1,
        pageSize: 25,
        sortBy: 'DESC',
      },
      loading: false,
      tableData: [],
      total: 0,
      selection: [],
      exportLoading: false,
    };
  },
  computed: mapState({
    // vendorType 0:常规业务 1:现货批发 2:专柜业务 3.现货批发2.0 4.奥莱业务
    specialSalesCounter: (state) => state.userinfo.vendorType === 2,
    // 是否是供货价白名单
    isPriceWhiteList: (state) => state.userinfo.isPriceWhiteList,
    // 店铺币种Code
    originalPriceUnit: (state) => state.userinfo.originalPriceUnit,
  }),
  watch: {
    '$i18n.locale': function () {
      this.getTableData();
    },
  },
  created() {
    getBrandList().then((res) => {
      this.brandList = res.data;
    });
    getCategoryList().then((res) => {
      this.categoryList = res.data.map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                item3.children = item3.children.length === 0 ? null : item3.children;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.brandIds = [];
      this.queryForm.designerId = null;
      this.queryForm.colorCode = null;
      this.queryForm.categoryIds = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      if (!this.fullscreenLoading) {
        this.loading = true;
      }
      getSeekList({
        ...this.queryForm,
        categoryIds: this.queryForm.categoryIds.map((item) => item[2]),
      }).then((res) => {
        if (res && res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
          this.loading = false;
        } else {
          this.loading = false;
          this.fullscreenLoading = false;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    changeSort(command) {
      this.queryForm.sortBy = command;
      this.getTableData();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSubmit() {
      setTimeout(() => {
        this.repeatSubmit = false;
      }, 1000);
    },
    orderItem(row) {
      this.$confirm(`${this.$t('buy.orderNowTip')}`, this.$t('common.warning'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'info',
      })
        .then(() => {
          seekOrder({
            seekOrderNo: row.seekOrderNo,
            saleOrderNo: row.saleOrderNo,
          }).then((res) => {
            this.$message(res.message);
            this.getTableData();
          });
        })
        .catch(() => {});
    },
    exportData() {
      this.exportLoading = true;
      exportSeekList({
        ...this.queryForm,
        categoryIds: this.queryForm.categoryIds.map((item) => item[2]),
      }).then((res) => {
        let fileName = `${this.$t('buy.purchaseOrder')}.xlsx`;
        const content = res.headers['content-disposition'];
        if (content) {
          fileName = content.substring(content.indexOf('=') + 1);
          fileName = window.decodeURI(fileName);
        }
        downloadBlobFile(res.data, fileName);
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagePos {
  padding: 20px 0;
}
.label {
  font-size: 12px;
  font-weight: 300;
}
.img-container {
  position: relative;
  min-height: 100px;
}
</style>
